<template>
  <v-autocomplete
    :label="label"
    :name="name"
    :value="value"
    :items="items"
    :loading="$apollo.queries.persons.loading"
    :search-input.sync="search"
    :hint="hint"
    v-bind="$attrs"
    @input="onInput"
    item-text="name"
    item-value="_id"
    clearable
    hide-no-data
    no-filter
  >
    <template v-slot:item="data">
      <v-list-item-content>
        <v-list-item-title>{{ data.item.name }}</v-list-item-title>
        <v-list-item-subtitle><v-icon x-small>perm_identity</v-icon> {{ data.item.personId }}</v-list-item-subtitle>
        <v-list-item-subtitle><v-icon x-small>email</v-icon> {{ data.item.email }}</v-list-item-subtitle>
        <v-list-item-subtitle><v-icon x-small>smartphone</v-icon> {{ data.item.phoneNumber }}</v-list-item-subtitle>
        <v-list-item-subtitle><v-icon x-small>groups</v-icon> {{ data.item.registrations.map(r => r.registration.memberNumber).filter(Boolean).join(', ') }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'PersonSearchField',

  props: {
    value: {
      type: String
    },
    label: {
      type: String,
      default: 'Person'
    },
    name: {
      type: String,
      default: 'person'
    },
    hint: {
      type: String,
      default: 'Search by name, email, or phone number'
    },
    exclude: {
      type: Array, // List of personIds to disable
      default: () => []
    },
    limit: {
      type: Number,
      default: 50
    }
  },

  data: () => ({
    persons: [],
    search: ''
  }),

  methods: {
    onError (e) {
      this.$emit('error', e)
    },

    onInput (event) {
      this.$emit('input', event)
    }
  },

  computed: {
    items () {
      return this.persons.map(person => ({
        disabled: this.exclude.includes(person._id),
        ...person
      }))
    }
  },

  apollo: {
    persons: {
      query: gql`query PersonSearchSearchPersons($search: FilterSearchManyPersonInput!, $limit: Int!) {
        persons: personSearchMany(search: $search, limit: $limit) {
          _id
          personId
          name
          email
          phoneNumber
          registrations {
            _id
            registration {
              _id
              memberNumber
            }
          }
        }
      }`,
      variables () {
        return {
          search: {
            _id: this.value,
            name: this.search,
            givenName: this.search,
            familyName: this.search,
            email: this.search,
            phoneNumber: this.search
          },
          limit: this.limit
        }
      },
      error (e) { this.onError(e) },
      debounce: 250
    }
  }
}
</script>
